import { classNames as cx } from "primereact/utils";
import { IMessage, MessageType } from "../../../../../../../models/Chat";
import { Image } from "primereact/image";

import { useKeycloakContext } from "../../../../../../../keycloak";

import classes from "./Message.module.scss";
import moment from "moment";
import { linkRegex } from "../../../../../../../constants/regex";

interface MessageProps {
  message: IMessage;
}

const formatTextWithLinks = (text: string): JSX.Element[] => {
  const parts: JSX.Element[] = [];
  let lastIndex = 0;
  let match;

  while ((match = linkRegex.exec(text)) !== null) {
    const link = match[0];
    const prefix = text.substring(lastIndex, match.index);

    if (prefix) {
      parts.push(<span key={lastIndex}>{prefix}</span>);
    }

    parts.push(
      <a
        key={match.index}
        href={link}
        target="_blank"
        rel="noopener noreferrer"
      >
        {link}
      </a>
    );

    lastIndex = match.index + link.length;
  }

  if (lastIndex < text.length) {
    parts.push(<span key={lastIndex}>{text.substring(lastIndex)}</span>);
  }

  return parts;
};

export function Message({ message }: MessageProps) {
  const keycloakContext = useKeycloakContext();

  const subId = keycloakContext?.keycloak?.tokenParsed.sub;

  return (
    <div
      key={message.id}
      className={cx(classes.messageContainer, {
        [classes.sender]: message.createdBy === subId,
      })}
    >
      <div className={classes.icon}>
        <i className="pi pi-user"></i>
      </div>
      <div
        className={cx(classes.message, {
          [classes.sender]: message.createdBy === subId,
          [classes.image]: message.type === MessageType.File,
        })}
      >
        <span className={classes.creator}>
          {message.creator.firstName + " " + message.creator.lastName}
        </span>
        <div className={classes.text}>
          {message.type === MessageType.Message ? (
            <span>{formatTextWithLinks(message.text)}</span>
          ) : (
            <Image
              src={`${process.env.REACT_APP_DSC_SERVICE_DOMAIN}/${message.text}`}
              alt="message-img"
              width="100"
              preview
            />
          )}
        </div>
        <div className={classes.date}>
          {moment(new Date(message.createdAt)).format("MM/DD/YYYY h:mm A")}
        </div>
      </div>
    </div>
  );
}
